import React from 'react';
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from './Tooltip';

interface SimpleTooltipProps {
  trigger: React.ReactNode;
  content: string | React.ReactNode | null;
  delayDuration?: number;
  testId?: string;
}

/**
 * A simple tooltip component that displays a tooltip when a trigger element is hovered over.
 *
 * Note: You may need to wrap the trigger element in a div to get the tooltip to display.
 *
 * @property trigger - The element that triggers the tooltip when hovered over
 * @property content - The text content of the tooltip
 * @property delayDuration - The delay duration in milliseconds before the tooltip appears
 */

export function SimpleTooltip({
  trigger,
  content,
  delayDuration = 200,
  testId,
}: SimpleTooltipProps) {
  return (
    <TooltipProvider delayDuration={delayDuration}>
      <Tooltip>
        <TooltipTrigger asChild data-testid={testId}>
          {trigger}
        </TooltipTrigger>
        {content === null ? null : (
          <TooltipContent side="top" align="start" style={{ zIndex: 999 }}>
            {content}
          </TooltipContent>
        )}
      </Tooltip>
    </TooltipProvider>
  );
}
